import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingDupeGroup } from './types/mailing-dupe-group.type';

/**
 * Retrieves the duplicate groups for a specific mailing.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing for which to fetch duplicate groups.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing {@link MailingDupeGroup} data.
 * @throws Throws an error if the request fails.
 */
export const getMailingDupeGroups = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingDupeGroup[]>>(
        formatString(Uri.mailing.getMailingDupeGroups, mailingId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
